import CheckCircleFilled from '@ixigo/icons/CheckCircleFilled';
import ChevronLeft from '@ixigo/icons/ChevronLeft';
import { IconButton } from '@ixigo/iui/IconButton';
import Typography from '@ixigo/iui/Typography';
import { preload } from 'react-dom';
import { USP_HIGHLIGHT_TITLES } from '@/constants';

const bannerBackground =
	'https://images.ixigo.com/image/upload/f_auto/cab/3640fed525f08843fde70adbcc192507-ztrbm.png';

interface SearchBannerProps {
	onBack: () => void;
}

export const SearchBanner = ({ onBack }: SearchBannerProps) => {
	preload(bannerBackground, { as: 'image' });
	return (
		<div
			className="absolute top-0 left-0 w-full h-48 bg-cover bg-center bg-no-repeat p-20 text-primary-inverse flex flex-col gap-2.5"
			aria-hidden="true"
			style={{
				backgroundImage: `url(${bannerBackground})`,
			}}
		>
			<div className="flex items-start gap-x-10 text-primary-inverse">
				<IconButton
					aria-label="Back"
					className="text-primary-inverse hover:bg-transparent -mt-1"
					onClick={onBack}
					edge="start"
				>
					<ChevronLeft />
				</IconButton>
				<div className="flex flex-col gap-y-5">
					<Typography
						variant="h5"
						fontWeight="bold"
						className="h-30 leading-[30px]"
					>
						Airport Cabs
					</Typography>
					<div className="text-primary-inverse flex items-center gap-x-5 px-5 py-0.5 rounded-5 bg-gradient-to-r from-[#E0CEBB4D] to-[#997B5D1A]">
						<CheckCircleFilled fontSize={18} />
						<Typography variant="body-2xs" fontWeight="medium">
							{USP_HIGHLIGHT_TITLES[0]}
						</Typography>
					</div>
					<div className="text-primary-inverse flex items-center gap-x-5 px-5 py-0.5 rounded-5 bg-gradient-to-r from-[#E0CEBB4D] to-[#997B5D1A]">
						<CheckCircleFilled fontSize={18} />
						<Typography variant="body-2xs" fontWeight="medium">
							{USP_HIGHLIGHT_TITLES[1]}
						</Typography>
					</div>
				</div>
			</div>
		</div>
	);
};
